var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXLogo = function SvgXLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    d: "M19.316 1.907h3.38l-7.384 8.44 8.686 11.483h-6.801l-5.327-6.965-6.095 6.965H2.393l7.897-9.026L1.958 1.907h6.974l4.815 6.367zm-1.186 17.9h1.872L7.914 3.824h-2.01z"
  })));
};
export default SvgXLogo;